import React from "react"
import styled from "styled-components"
import {Row} from "react-bootstrap"

import media, {minWidthMedia} from "@irati/ui/src/global/media"
import {H2, Body} from "@irati/ui/src/Typography"

import AdminHeader from "../../AdminHeader/AdminHeader"

export const Div = (props: any) => <div {...props} />

export const PageHeader = styled(Row)`
  margin-bottom: 50px;
`

export const BenefitHeader = styled(Body)`
  max-width: 250px;
  white-space: pre-wrap;
  word-wrap: break-word;

  ${minWidthMedia.largeDesktop`
    max-width: 400px;
  `}
`

export const TitleAndCount = styled(AdminHeader)`
  ${H2} {
    ${media.largeDesktop`
      font-size: 38px;
    `}
  }
`
